const React = require('react');
const PropTypes = require('prop-types');
const { formatValue } = require('../utilities/valueFormater');

const CustomTooltip = props => (
    <div className="tab-profitability__profitability-chart__tooltip">
        <p>
            <b>{props.label}</b>
        </p>
        {props.payload.map(entry => (
            <p key={entry.name}>
                <span
                    className="disk"
                    style={{ backgroundColor: entry.color }}
                />
                &nbsp;
                {formatValue(entry.value)}
                {entry.unit}
            </p>
        ))}
    </div>
);

CustomTooltip.defaultProps = {
    label: '',
    payload: [],
};

CustomTooltip.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    payload: PropTypes.array,
};

module.exports = CustomTooltip;
